<template>
  <v-card class="email-files-save-panel">
    <div class="email-files-save-header">
      <v-icon small class="mr-1">mdi-content-save</v-icon>
      Save selected pages
    </div>

    <div class="email-files-save-body">
      <div v-if="selectedPages.length" class="mb-3">
        <div class="email-files-save-count mb-2">
          {{ selectedPages.length }}
          {{ selectedPages.length === 1 ? "page" : "pages" }} selected
        </div>
        <v-chip
          v-for="page in selectedPages"
          :key="page.key"
          small
          class="ma-1"
          outline
          color="success"
        >
          {{ page.fileName }} · p.{{ page.pageNumber }}
        </v-chip>
      </div>
      <div v-else class="email-files-save-empty">
        <v-icon class="email-files-save-empty-icon"
          >mdi-checkbox-blank-outline</v-icon
        >
        <div>Select pages to save.</div>
      </div>
      <div v-if="selectedPages.length">
        <div class="email-files-save-label mb-2">
          <v-icon small color="success" class="mr-1">mdi-file-document</v-icon>
          Document details
        </div>
        <v-select
          outline
          hide-details
          class="mb-3"
          label="Save as"
          :items="docTypeItems"
          v-model="selectedDocTypeId"
          @change="selectedStudentId = ''"
        ></v-select>

        <v-select
          v-if="requireStudent"
          outline
          hide-details
          class="mb-3"
          label="Student"
          :items="studentItems"
          v-model="selectedStudentId"
        ></v-select>

        <v-text-field
          outline
          hide-details
          class="mb-3"
          label="Document name"
          required
          v-model="selectedFileName"
        ></v-text-field>

        <v-btn
          color="success"
          block
          class="email-files-save-btn"
          :disabled="!canSave"
          :loading="saving"
          @click="$emit('save')"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save to student
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "EmailFilesSavePanel",
  props: {
    accountId: {
      type: String,
      default: "",
    },
    students: {
      type: Array,
      default() {
        return [];
      },
    },
    docTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedPages: {
      type: Array,
      default() {
        return [];
      },
    },
    studentId: {
      type: String,
      default: "",
    },
    docTypeId: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedStudentId: {
      get() {
        return this.studentId;
      },
      set(value) {
        this.$emit("update:studentId", value);
        if (value) {
          const student = this.students.find((s) => s.studentID === value);
          const studentName = (
            (student &&
              (student.engName || student.hebName || student.studentID)) ||
            ""
          ).trim();
          this.selectedFileName = `${this.selectedDocTypeId.trim()}_${studentName}_${this.accountId.trim()}`;
        }
      },
    },
    selectedDocTypeId: {
      get() {
        return this.docTypeId;
      },
      set(value) {
        this.$emit("update:docTypeId", value);
        this.selectedFileName = `${value.trim()}_${this.accountId.trim()}`;
      },
    },
    selectedFileName: {
      get() {
        return this.fileName;
      },
      set(value) {
        this.$emit("update:fileName", value);
      },
    },
    requireStudent() {
      const REQUIRE_STUDENT = ["12G", "CH205", "IMM"];
      return REQUIRE_STUDENT.includes(this.docTypeId.toString().trim());
    },

    studentItems() {
      const items = [];
      this.students.forEach((student) => {
        const name = student.engName || student.hebName || student.studentID;
        items.push({
          text: name,
          value: student.studentID,
        });
      });

      return items;
    },

    docTypeItems() {
      return this.docTypes.map(function(type) {
        const label = type.docDescription || type.docTypeID;
        if (
          type.docTypeID &&
          type.docDescription &&
          type.docDescription !== type.docTypeID
        ) {
          label = type.docDescription + " (" + type.docTypeID + ")";
        }
        return {
          text: label,
          value: type.docTypeID,
        };
      });
    },
    canSave() {
      if (
        !this.selectedPages.length ||
        this.saving ||
        !this.docTypeId ||
        !this.fileName
      ) {
        return false;
      }
      if (this.requireStudent && !this.studentId) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
.email-files-save-panel {
  position: sticky;
  top: 16px;
  border-radius: 8px !important;
  overflow: hidden;
}

.email-files-save-header {
  display: flex;
  align-items: center;
  background: #4caf50;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
}

.email-files-save-header .v-icon {
  color: #fff !important;
}

.email-files-save-body {
  padding: 16px;
}

.email-files-save-count {
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.email-files-save-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.email-files-save-empty {
  text-align: center;
  color: #9e9e9e;
  padding: 24px 8px 8px;
  font-size: 13px;
}

.email-files-save-empty-icon {
  display: block;
  font-size: 36px !important;
  color: #c8e6c9 !important;
  margin-bottom: 8px;
}

.email-files-save-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  margin-top: 4px;
}
</style>
